module.exports = __webpack_public_path__ + "static/media/homewallpaper.b4438b00.png";